module.exports = __webpack_public_path__ + "assets/img/m1.98653a98.png";